class TokensExpiredError extends Error {
  constructor(message) {
    // call the Error constructor with the error message
    super(message);

    // set the name of the error as CustomError
    // so that logger or error handler can recognize this as a custom error
    this.name = "TokensExpiredError";

    // maintain proper stack trace
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

export default TokensExpiredError;
